import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { ContentWrapper } from 'components';
import './preview-image.scss';


export function PreviewImage({ open, image, dimensions, id, togglePreview, cancelPreview, confirmImage, buttons, file }) {

  const [width, setWidth] = useState();
  const [height, setHeight] = useState();
  const [name, setName] = useState();
  const [recommended, setRecommended] = useState();


  useEffect(() => {
    setWidth(dimensions?.width);
    setHeight(dimensions?.height);
    setName(dimensions?.name);
    setRecommended(getRecommended(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimensions])

  const recommendedSizes = [
    {
      id: 'fileLogo',
      recommended: {
        width: 100,
        height: 110
      }
    },
    {
      id: 'fileAvatar',
      recommended: {
        width: 100,
        height: 100
      }
    },
    {
      id: 'fileBanner',
      recommended: {
        width: 1440,
        height: 575
      }
    }
  ]

  const getRecommended = (id) => {
    return recommendedSizes.filter((input) => {
      return input.id === id;
    })
  }

  const toggle = () => {
    togglePreview();
  }

  const cancelTogglePreview = () => {
    cancelPreview()
  }

  const confirmPreviewImage = () => {
    confirmImage();
    toggle();
  }

  const renderButtons = (render) => {
    if (render) {
      return (
        <ContentWrapper>
          <Button color="secundary" onClick={cancelTogglePreview}>Cancelar</Button>
          <Button color="primary" onClick={confirmPreviewImage}>Confirmar</Button>
        </ContentWrapper>
      )
    }
  }

  const renderTitle = (render) => {
    return render ?
      <ModalHeader toggle={cancelTogglePreview}> Deseja fazer upload da imagem <b> {name} </b>?</ModalHeader> :
      <ModalHeader toggle={cancelTogglePreview}> Você está visualizando a imagem <b> {name || file?.value?.name} </b></ModalHeader>
  }

  const renderDimensions = (render) => {
    if (render) {
      return <CardDimensions width={width} height={height} recommended={recommended} />
    }
  }

  return (
    <Modal className={"preview-image"} isOpen={open} toggle={cancelTogglePreview}>
      {renderTitle(buttons)}
      <ModalBody>
        <img id="preview" className="preview" alt="Imagem de preview" src={ image || file?.value?.directory } />
      </ModalBody>
      <ModalFooter>
        {renderDimensions(buttons)}
        {renderButtons(buttons)}
      </ModalFooter>
    </Modal>
  )
}

export function CardDimensions({ width, height, recommended }) {

  const sizes = recommended[0]?.recommended;

  return (
    <div className="card-dimensions">
      <b> Largura: </b>{`${width}px`}
      <br />
      <b> Altura: </b>{`${height}px`}
      <br />
      <b> Recomendado: </b>{`${sizes?.width}px de largura e ${sizes?.height}px de altura`}
    </div>
  )
}
